"use client";

import { cva } from "cva";
import { cn } from "#ui-atoms/lib/utils";
import {
  BaseSelect,
  BaseSelectItem,
  type BaseSelectItemProps,
  BaseSelectPopup,
  type BaseSelectPopupProps,
  BaseSelectTrigger,
  type BaseSelectTriggerProps,
  SelectGroup,
  SelectGroupLabel,
  SelectSeparator,
  SelectValue,
} from "./select";
import type { SelectParts } from ".";

// Select Trigger
const conEdisonSelectTriggerVariants = cva({
  base: [
    "h-[2.5rem] w-full rounded-b-none border-none p-0 pb-1 text-center !text-2xl font-semibold !outline-none !ring-0 !ring-offset-0 ring-offset-transparent focus-visible:!border-none focus-visible:ring-0 focus-visible:ring-offset-0 sm:text-[2rem]",
    "justify-center gap-2",
    "hover:scale-[101.25%] focus-visible:scale-[101.25%]",
  ],
});

function ConEdisonSelectTrigger({
  className,
  ...props
}: BaseSelectTriggerProps) {
  return (
    <BaseSelectTrigger
      {...props}
      className={cn(conEdisonSelectTriggerVariants({ className }))}
    ></BaseSelectTrigger>
  );
}

// Select Popup
const conEdisonSelectPopupVariants = cva({
  base: ["rounded-none"],
});

function ConEdisonSelectPopup({ className, ...props }: BaseSelectPopupProps) {
  return (
    <BaseSelectPopup
      {...props}
      className={cn(conEdisonSelectPopupVariants({ className }))}
    ></BaseSelectPopup>
  );
}

// Select Item
const conEdisonSelectItemVariants = cva({
  base: "rounded-none font-semibold focus:bg-tenant-con-edison-website-table-row-odd",
  variants: {
    tenantVariant: {
      "oru-reco": null,
    },
  },
  defaultVariants: {},
  compoundVariants: [
    {
      tenantVariant: ["oru-reco"],
      className: "focus:bg-tenant-oru-website-table-row-odd",
    },
  ],
});

function ConEdisonSelectItem({
  className,
  tenant,
  ...props
}: BaseSelectItemProps) {
  const tenantVariant =
    tenant?.variantId === "oru-reco" ? "oru-reco" : undefined;

  return (
    <BaseSelectItem
      {...props}
      className={cn(
        conEdisonSelectItemVariants({
          className,
          ...(tenantVariant && { tenantVariant }),
        }),
      )}
    ></BaseSelectItem>
  );
}

export { ConEdisonSelectTrigger, ConEdisonSelectPopup, ConEdisonSelectItem };

export const conEdisonSelectKit: SelectParts = {
  Root: BaseSelect,
  Trigger: ConEdisonSelectTrigger,
  Value: SelectValue,
  Popup: ConEdisonSelectPopup,
  Item: ConEdisonSelectItem,
  Separator: SelectSeparator,
  Group: SelectGroup,
  GroupLabel: SelectGroupLabel,
};
